import { RouteConfig } from "vue-router";
import createSumPayment from '../../routes-children/create-sum-payment';

export default {
	name: "CreateSumPayment",
	path: "/create-sum-payment",
	component: () => import('@/views/Home/CreateSumPayment.vue'),
	meta: {
		layout: "main"
	},
	children: createSumPayment
} as RouteConfig;